import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Breadcrumb from "../Component/BradeCrum";
import HeaderMobile from "../Component/MobileHader";
import { Hourglass } from "react-loader-spinner";

const OurNetwork = () => {
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    
    axios
      .get(`${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/get/allnetwork`)
      .then((res) => {

        setContent(res.data);
      
      })
      .catch((err) => console.log(err));
  }, []);
    useEffect(() => {
      const handleLoading = async () => {
        setLoading(true); // Start loading
        window.scrollTo(0, 0);
  
        // Simulate loading for demonstration purposes
        await new Promise((resolve) => setTimeout(resolve, 2000));
  
        setLoading(false); // Stop loading
      };
  
      handleLoading();
    }, []);
  return (
    <React.Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Hourglass
            height={80}
            width={80}
            color="#01458e"
            ariaLabel="loading-content"
          />
        </div>
      ) : (
        <div>
          <HeaderMobile />
          <Breadcrumb heading="Our Network" bTitle="Our Network" />
          <Container className="galleryRow ">
            {(!content || content.length === 0) && (
              <h2>Content will be coming soon...</h2>
            )}
            <ul>
              {Object.entries(content)
                .filter((items) => items[1].IsActive === true)
                .map(([key, value]) => (
                  <>
                    <br />
                    <h3
                      style={{
                        backgroundColor: "#01458e",
                        color: "white",
                        padding: "5px 5px",
                        fontSize: "15px",
                      }}
                    >
                      {value.heading}
                    </h3>
                    <Row>
                      <Col
                        lg={4}
                        key={value}
                        style={{
                          padding: "8px 15px",
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        Address :- {value.address}
                      </Col>
                      <Col
                        lg={4}
                        key={value}
                        style={{
                          padding: "8px 15px",
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        Contact :- {value.contactnumber1}
                      </Col>
                      <Col
                        lg={4}
                        key={value}
                        style={{
                          padding: "8px 15px",
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                      >
                        Email :- {value.email1}
                      </Col>
                      {value.contactnumber2 && (
                        <Col
                          lg={4}
                          key={value}
                          style={{
                            padding: "8px 15px",
                            fontWeight: "bold",
                            fontSize: "15px",
                          }}
                        >
                          Contact :- {value.contactnumber2}
                        </Col>
                      )}
                      {value.email2 && (
                        <Col
                          lg={4}
                          key={value}
                          style={{
                            padding: "8px 15px",
                            fontWeight: "bold",
                            fontSize: "15px",
                          }}
                        >
                          Email :- {value.email2}
                        </Col>
                      )}
                    </Row>
                  </>
                ))}
            </ul>
          </Container>
        </div>
      )}
    </React.Fragment>
  );
};

export default OurNetwork;
